import React, { useState } from 'react'
import styles from './profilebody.module.css';
import EditShipping from '../addEditAddress/EditShipping';
import AddShipping from '../addEditAddress/AddShipping';
import { useParams } from 'react-router-dom';
import AddBilling from '../addEditAddress/AddBilling';
import { useDispatch, useSelector } from 'react-redux';
import { setCustomerEditData } from '../../../../Website/redux/customerSlice';
import AddressTable from './AddressTable';

const ShippingAddress = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const [isAddShipPopupOpen, setAddShipPopupOpen] = useState(false);
    const [isEditShipPopupOpen, setEditShipPopupOpen] = useState(false);
    const { customer } = useSelector((state) => state.customer)



    const openAddShipPopup = () => {
        dispatch(setCustomerEditData({}))
        setAddShipPopupOpen(true);
    };

    const handleEditClick = async (data) => {
        await dispatch(setCustomerEditData(data))
        setEditShipPopupOpen(true)
    }

    return (
        <div className={`${styles.profilebodyContainer} ${styles.addressPolish}`}>
            <div className={styles.profileheader}>
                <div className={styles.addressTitleBlock}>
                    <span>ADDRESS BOOK</span>
                    <h2>Shipping addresses</h2>
                    <p>Manage delivery locations for your orders.</p>
                </div>
                <button className={styles.addressAddButton} onClick={openAddShipPopup}>+ Add shipping address</button>
                {isAddShipPopupOpen && <AddBilling
                    onClose={() => setAddShipPopupOpen(false)}
                    heading={'Add New Shipping Address'}
                    from="csa"
                    parent="shipping"
                />
                }
            </div>
            <div className={styles.profilebodyContent}>
                <div className={styles.address_container}>

                    {customer?.shippingAddress?.length > 0 ?
                        <>
                            <AddressTable
                                heading="Shipping"
                                customer={customer}
                                addressData={customer?.shippingAddress}
                                handleEditClick={handleEditClick}

                            />
                            {isEditShipPopupOpen &&
                                <AddBilling
                                    onClose={() => setEditShipPopupOpen(false)}
                                    heading={'Edit New Billing Address'}
                                    from="cbe"
                                    parent="shipping"
                                />
                            }
                        </>
                        :
                        <div className={styles.addressEmpty}>No shipping addresses yet. Add one when you are ready.</div>
                    }

                </div>
            </div>
        </div>
    )
}

export default ShippingAddress
